
<script>
import CardInput from '../sub-pages/card-input.vue'
import SecurityInformation from '../sub-pages/security-information.vue'
import sharedService from '../../../../utils/shared-service'
import { EventBus } from '../../../../event-bus.js'
import { mapGetters } from 'vuex'
import { CONSTANT, CARDS_ERROR, DEFAULT_CHECKOUT_EXPERIENCE, windowRefTypes } from '../../../../utils/constant'
import checkout from '../../../../utils/checkout'

export default {
  name: 'AddCard',
  components: {
    CardInput,
    SecurityInformation
  },
  data () {
    return {
      close: true,
      error: '',
      CONSTANT: CONSTANT,
      prevRoute: null,
      isCardValid: true
    }
  },

  computed: {
    ...mapGetters(['isError', 'dpaTransactionOptions', 'isRecognized',
      'srcKeys', 'enrollEncryptedCard', 'selectedCheckoutExperience', 'payloadRequested', 'authPreference', 'isConsumerAuthModuleEnable', 'windowRefType'])
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },

  beforeDestroy () {
    this.$store.dispatch('isError', false)
  },

  mounted () {
    EventBus.$on('handleError', (event) => {
      this.error = event
      setTimeout(() => {
        this.error = ''
      }, 3000)
    })
  },

  methods: {

    /**
     * This method routes to the previous screen
     */
    goBack () {
      if (this.prevRoute && this.prevRoute.path.includes('payment-method')) {
        this.$router.push(this.prevRoute.path).catch(err => { console.error(err) })
      } else {
        EventBus.$emit('switchPage', CONSTANT.INLINE_SCREEN.PAYMENT_SCREEN)
      }
    },

    /**
     * This method emit add card and calls enroll sdk
     */
    submit () {
      this.addCard()
    },

    /**
     * This method calls the add card api which internal calls enroll card
     */
    async addCard () {
      try {
        let cardDetails = {
          primaryAccountNumber: sharedService.unmask(this.$refs.cardNumber.cardNumber),
          panExpirationMonth: this.$refs.securityInfo.expiry.split('/')[0],
          panExpirationYear: `${new Date().getFullYear().toString().substr(0, 2)}${this.$refs.securityInfo.expiry.split('/')[1]}`,
          cardSecurityCode: this.$refs.securityInfo.cvc2,
          network: this.$refs.cardNumber.cardType
        }
        this.isCardValid = sharedService.validateCardDetails(cardDetails)
        if (this.isCardValid) {
          await this.checkout(cardDetails)
        }
      } catch (error) {
        console.log(error)
        this.error = error.errors[0].reason
        EventBus.$emit('handleError', this.error)
      }
    },

    /**
     * This method is use to invoke popup experince
     */
    invokePopup () {
      if (!window.opener) {
        sharedService.invokeSrc(false, CONSTANT.SRC.INLINE_CARD, this.$store)
      }
    },

    /**
     * This method is use to set window Reference (popup,actionsheet/iframe)for DCF
     */
    setWindowReference (cardDetail) {
      if (this.isConsumerAuthModuleEnable && this.windowRefType === windowRefTypes.ACTION_SHEET) {
        this.$store.dispatch('lightBoxloaderOn', true)
        this.$parent.$refs.authenticationIframe.addEventListener('load', () => {
          this.$store.dispatch('lightBoxloaderOn', false)
          EventBus.$emit('visibleActionsheet', false)
        })
        window.checkoutIframeRef = this.$parent.$refs.authenticationIframe.contentWindow
      } else {
        this.$store.dispatch('lightBoxloaderOn', true)
        let isIframe = true
        const isDefaultExperiance = this.selectedCheckoutExperience !== DEFAULT_CHECKOUT_EXPERIENCE
        const isiFramePFL = this.isConsumerAuthModuleEnable && this.windowRefType === windowRefTypes.IFRAME
        if (this.authPreference && cardDetail.network === 'mastercard' && sharedService.checkFeatureFlag('START_LMC_CHANGES')) {
          isIframe = !(this.payloadRequested === 'AUTHENTICATED')
        }
        if ((isiFramePFL || isDefaultExperiance) && isIframe) {
          this.$refs.cardNumber.$refs.iframe.addEventListener('load', () => {
            this.$store.dispatch('lightBoxloaderOn', false)
            this.$store.commit('checkoutProgress', true)
            this.$refs.cardNumber.$refs.iframeContainer.classList.add('show')
          })
          this.$refs.cardNumber.$refs.iframeBackground.addEventListener('click', () => {
            this.$store.commit('checkoutProgress', false)
          })
          window.checkoutIframeRef = this.$refs.cardNumber.$refs.iframe.contentWindow
        } else {
          this.invokePopup()
        }
      }
    },

    /**
     * This method calls the checkout when user adds new card
     * @param cardDetail
     * @returns {Promise<void>}
     */
    async checkout (cardDetail) {
      this.setWindowReference(cardDetail)
      let windowRef = !window.opener ? checkout : window.opener.checkout
      await windowRef.initiate({
        cardDetail,
        enrollCard: true
      }).catch(error => {
        this.$store.dispatch('lightBoxloaderOn', false)
        console.log(error)
        this.error = CARDS_ERROR
        EventBus.$emit('handleError', this.error)
      })
    }
  }
}
</script>

<template>
  <div>
    <div
      v-if="error"
      id="addCardErrorMessage"
      class="enroll-card-sdk-error alert alert-danger"
      role="alert"
    >
      {{ $t('errorMessages.' +error) }}
    </div>
    <div
      v-if="isError"
      class="alert alert-danger"
      role="alert"
    >
      {{ $t ('errorMessages.profileError') }}
    </div>
    <div class="pb-3">
      <div class="form-group mt-4">
        <h4 class="font-weight-bold">
          {{ $t ('label.cardInfo') }}
        </h4>
        <div class="mt-5">
          <card-input
            ref="cardNumber"
          />
        </div>
      </div>
      <security-information
        ref="securityInfo"
      />
    </div>
    <div class="text-center mt-5 pt-3">
      <button
        id="add-card-btn"
        class="btn btn-dark lightbox-btn btn-lg"
        data-test="btn-continue"
        type="submit"
        @click="submit()"
      >
        {{ $t ('label.addCard') }}
      </button>
      <div class="text-center mt-2">
        <span
          class="btn-footer"
          @click="goBack()"
        >
          {{ $t('label.goBack') }}
        </span>
      </div>
    </div>
  </div>
</template>
